module.exports = __webpack_public_path__ + "img/bg_wuquan.861152fe.png";